import { TreeItem, TreeView } from '@material-ui/lab';
import {
  Box,
  Checkbox,
  makeStyles,
  Typography,
  withStyles
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import { useEffect, useState } from 'react';




const useStyles = makeStyles(theme => ({
  accordionContainer: {
    width: '100%',
    height: '60vh',
    flexGrow: 1,
    overflow: 'auto',
  },
  tree: {
    width: '100%',
  },
  rtControl: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  rtTypeBox: {
    display: 'flex',
    minWidth: '40%',
    justifyContent: 'center',
  },
  dsControl: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  dsTypeBox: {
    display: 'flex',
    minWidth: '40%',
    justifyContent: 'center',
  },
  noRecords: {
    padding: theme.spacing(1),
    paddingLeft: theme.spacing(3),
  },
  customCheckboxFormControl: {
    display: 'flex',
    alignItems: 'center',
  },
  customCheckboxFormControlLabel: {
    paddingTop: 1,
  },
}));


const Accordion = withStyles({
  root: {
    borderTop: '1px solid rgba(0, 0, 0, .125)',
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
    },
  },
  expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    backgroundColor: 'rgba(0, 0, 0, .1)',
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    marginBottom: -1,
    minHeight: 56,
  },
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: 0,
  },
}))(MuiAccordionDetails);

const RecordTypeTreeItem = withStyles((theme) => ({
  root: {
    padding: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    paddingRight: 0,
    borderTopWidth: 'thin',
    borderTopColor: 'lightgrey',
    borderTopStyle: 'solid'
  },
}))((props) => <TreeItem {...props}/>);

// Like a checkbox form control except user cannot toggle checkbox from the label
const CustomCheckboxFormControl = ({label, checked, onToggle}) => {
  const classes = useStyles();
  return (
    <Box className={classes.customCheckboxFormControl}>
      <Checkbox
        checked={checked}
        onClick={(event) => {
          event.stopPropagation();
        }}
        onChange={(event, checked) => onToggle(checked)}
      />
      <Box className={classes.customCheckboxFormControlLabel}>{label}</Box>
    </Box>
  )
};

const RecordTypeControl = (props) => {
  const { rtName, rtSubcategory, checked, onToggle } = props;
  const classes = useStyles();
  return (
    <Box className={classes.rtControl}>
      {onToggle && <CustomCheckboxFormControl label={rtName} checked={checked} onToggle={onToggle}/>}
      {!onToggle && <Box>{rtName}</Box>}
      <Box className={classes.rtTypeBox}>{rtSubcategory}</Box>
    </Box>
  )
};

const DescriptionTypeTreeItem = withStyles((theme) => ({
  root: {
    padding: theme.spacing(1),
    paddingRight: 0,
    borderTopWidth: 'thin',
    borderTopColor: 'lightgrey',
    borderTopStyle: 'solid',
  },
}))((props) => <TreeItem {...props}/>);

const DescriptionTypeControl = (props) => {
  const { dsName, dsType, count } = props;
  const classes = useStyles();
  return (
    <Box className={classes.dsControl}>
      <Box>{dsName}{(count ? ` (${count})` : '')}</Box>
      <Box className={classes.dsTypeBox}>{dsType}</Box>
    </Box>
  )
};

const ListValueTreeItem = withStyles((theme) => ({
  root: {
    padding: theme.spacing(1),
    borderTopWidth: 'thin',
    borderTopColor: 'lightgrey',
    borderTopStyle: 'solid'
  },
}))((props) => <TreeItem {...props}/>);

const ProjectSchema = ({
  schema,
  schemaEditState = null,
  schemaEditDispatch = null,
  selectableRT = false,
}) => {
  const classes = useStyles();

  const [expandedAccordionNodes, setExpandedAccordionNodes] = useState({});
  const [expandedTreeNodes, setExpandedTreeNodes] = useState({});

  useEffect(() => {
    setExpandedTreeNodes([]);
  }, [schema])

  let rtCategories = [];
  if (schema && schema.allRecordTypes) {
    rtCategories = schema.allRecordTypes.reduce((rtCategories, rt) => {
      const category = (rtCategories[rt.category] || []);
      category.push(rt);
      rtCategories[rt.category] = category;
      return rtCategories;
    }, {});
  }

  const addRemoveRTSelection = (rt, selected) => {
    if (selected) {
      schemaEditDispatch({ type: 'SELECT_RECORD_TYPE', rt })
    } else {
      schemaEditDispatch({ type: 'DESELECT_RECORD_TYPE', rt })
    }
  }

  const RTSchemaCategory = ({recordTypes, categoryLabel}) => (
    <Accordion
      square
      TransitionProps={{ unmountOnExit: true }}
      expanded={expandedAccordionNodes[categoryLabel]}
      onChange={(event, expanded) => {setExpandedAccordionNodes({...expandedAccordionNodes, [categoryLabel]: expanded})}}
    >
      <AccordionSummary>
        <Box>
          <Typography>{categoryLabel} ({(recordTypes && recordTypes.length) || 0})</Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        {recordTypes &&
        <TreeView
          className={classes.tree}
          disableSelection={true}
          defaultCollapseIcon={<ExpandMoreIcon/>}
          defaultExpandIcon={<ChevronRightIcon/>}
          defaultExpanded={expandedTreeNodes[categoryLabel]}
          onNodeToggle={(event, nodeIds) => setExpandedTreeNodes({...expandedTreeNodes, [categoryLabel]: nodeIds})}
        >
          {recordTypes.map((rt, rtIndex) => (
            <RecordTypeTreeItem key={rtIndex}
                                nodeId={`rt-${rt.id}`}
                                label={<RecordTypeControl
                                  checked={schemaEditState.selections[rt.id] != null}
                                  rtName={rt.name}
                                  rtSubcategory={rt['sub_category']}
                                  onToggle={selectableRT ? (checked) => addRemoveRTSelection(rt, checked) : null}
                                />}>
              {rt.descriptions && rt.descriptions.map((desc, descIndex) => (
                <DescriptionTypeTreeItem key={descIndex} nodeId={`dsc-${rt.id}-${desc.id}`}
                                         label={<DescriptionTypeControl dsName={desc.name} dsType={desc.type} count={desc.listValues && desc.listValues.length}/>}>
                  {desc.listValues && desc.listValues.map((val, valIndex) => (
                    <ListValueTreeItem key={valIndex} nodeId={`lv-${rt.id}-${desc.id}-${val.id}`} label={val.value}/>
                  ))}
                </DescriptionTypeTreeItem>
              ))}
            </RecordTypeTreeItem>
          ))}
        </TreeView>
        }
        {!recordTypes &&
          <Box className={classes.noRecords}>
            <Typography variant='body1'>No {categoryLabel} defined</Typography>
          </Box>
        }
      </AccordionDetails>
    </Accordion>
  );

  return (
    <Box>
        {rtCategories &&
        <Box className={classes.accordionContainer}>
          <RTSchemaCategory categoryLabel="Materials" recordTypes={rtCategories['material']}/>
          <RTSchemaCategory categoryLabel="Containers" recordTypes={rtCategories['container']}/>
          <RTSchemaCategory categoryLabel="Locations" recordTypes={rtCategories['location']}/>
          <RTSchemaCategory categoryLabel="Tasks" recordTypes={rtCategories['task']}/>
        </Box>
        }
    </Box>
  )
};

export default ProjectSchema;
